export default function TextArea(
  props: React.TextareaHTMLAttributes<HTMLTextAreaElement>
) {
  return (
    <textarea
      rows={6}
      className=" w-full rounded-md border p-2 text-base"
      {...props}
    />
  );
}
